// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { Auth } from 'aws-amplify'
import ReactGA from 'react-ga4'
import { updateHeaderToken } from 'helpers/api'
import { measurementId } from 'constants/userPool'

const validateUser = () => dispatch => (
  dispatch(loadingToggler(
    async () => {
      let groups = []
      let user = null
      let GA_userId = null

      try {
        const auth = await Auth.currentAuthenticatedUser()

        const {
          accessToken,
          idToken,
        } = auth.signInUserSession

        // updates the Headers used in fetchWrapper with the new token.
        updateHeaderToken(idToken.jwtToken)

        // if the user has no groups assigned, this value is undefined in the payload.
        // use an empty array as fallback for simple checking elsewhere.
        groups = accessToken.payload['cognito:groups'] || []

        // pull the user object out from Amplify now that it's signed the user in.
        user = Auth.user

        // get some details about this user to track in Google Analytics
        const {
          email,
          sub,
        } = user.attributes

        // This will extract the domain from the user's email.
        // This supports sub domains and will warn us if there's ever an email address which doesn't work with the regex for some reason.
        const userDomain = email.match(/^.+@(.+)\.\w+$/i)

        // we store use a combination of the email's domain and the Amplify 'sub' to
        // create a userId in Google Analytics.
        GA_userId = `${userDomain[1] || 'Invalid_Domain_Match'}__${sub}`

        ReactGA.gtag('config', measurementId, {
          user_id: sub,
        })

        // just in case we ever have an email which isn't properly caught by the .match() above, we'll know about it through analytics.
        if (userDomain.length !== 2) {
          ReactGA.event({
            action: 'Domain was not properly extracted from the user\'s email.',
            category: 'User',
            label: GA_userId,
          })
        }

        ReactGA.event({
          action: 'Logged in.',
          category: 'User',
          label: GA_userId,
        })
      } catch (err) {
        console.warn(err)

        // clear out the stored token
        updateHeaderToken('')
      }

      return {
        GA_userId,
        groups,
        user,
      }
    })
  )
)

export default validateUser
